export default __webpack_public_path__ + "static/media/2498.3554f5f5.png";